// extracted by mini-css-extract-plugin
module.exports = {"iframe-dialog--body":"iframe-dialog--body__sgavg","iframe-dialog--iframe":"iframe-dialog--iframe__AHxY3"};